import React from "react";
import {CalendarEntry, StaffLink, Venue} from "../../api/grs";
import store from "../../store/Store";
import {formatUnixToHHmm} from "../../utils/momentUtils";

export interface OverlapWarningProps {
    overlappingEvents: CalendarEntry[];
    staff: StaffLink;
    currentEvent: CalendarEntry;
    allowable: boolean;
}

export default function OverlapWarning(props: OverlapWarningProps) {
    const venues = store.getState().venueList.data ?? [];
    const venueName = getVenueName(props.currentEvent.venueId, venues);

    return (
        <div>
            <p>
                {props.staff.staffName} has been assigned to another event on this day, but at a
                different time to this assignment.
            </p>

            <h2 className="subheading">New assignment</h2>
            <ul>
                <li>
                    {props.currentEvent.description} at {venueName}:{" "}
                    {formatUnixToHHmm(props.currentEvent.startDate)} -{" "}
                    {formatUnixToHHmm(props.currentEvent.endDate)}
                </li>
            </ul>

            <h2 className="subheading">
                Other events this staff member is assigned to on this day
            </h2>
            {props.overlappingEvents.length > 0 ? (
                <ul>
                    {props.overlappingEvents.map((event, index) => (
                        <li key={index}>
                            {event.description || "No Description"} at{" "}
                            {getVenueName(event.venueId, venues)}:{" "}
                            {formatUnixToHHmm(event.startDate)} - {formatUnixToHHmm(event.endDate)}
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No overlapping events found.</p>
            )}

            {props.allowable && <p>Would you like to assign this staff member anyway?</p>}
            {!props.allowable && <p>This assignment cannot be made due to overlapping events.</p>}
        </div>
    );
}

function getVenueName(venueId: number | null | undefined, venues: Venue[]): string {
    if (!venueId) return "Unknown Venue";
    const venue = venues.find((v) => v.id === venueId);
    return venue ? venue.name : "Unknown Venue";
}
